import { getObjectValue } from '@services/object-extensions';
import { JsonResponseParser } from './json-response.parser';

export class TechnologiesParser extends JsonResponseParser {
  /**
   * Parses the response into a JSON.
   * @param {*} response
   */
  parse(response) {
    const sections = super.parse(response);
    const mainSectionDescriptions = {
      title: getObjectValue(sections, 'title', ''),
      subtitle: getObjectValue(sections, 'subtitle', ''),
      paragraph: getObjectValue(sections, 'body', '')
    };

    const mainSectionDarkTheme = getObjectValue(sections, 'dark', false);
    const mainSectionImageUrl = getObjectValue(sections, 'imgUrl', '');

    const navbarItems = getObjectValue(sections, 'childTecnologies', [])?.map((element) => ({
      title: getObjectValue(element, 'title', ''),
      target: getObjectValue(element, 'customId', '')
    }));

    const pages = getObjectValue(sections, 'childTecnologies', [])?.map((element) => ({
      categoryId: getObjectValue(element, '_id', ''),
      id: getObjectValue(element, 'customId', ''),
      title: getObjectValue(element, 'title', ''),
      darkTheme: getObjectValue(element, 'dark', false),
      backgroundImage: getObjectValue(element, 'imgUrl', ''),
      additionalInfo: getObjectValue(element, 'additionalInfo', [])?.map((el) => ({
        title: getObjectValue(el, 'title', ''),
        body: getObjectValue(el, 'body', '')
      })),
      buttons: getObjectValue(element, 'childTecnologies', [])?.map((el) => ({
        description: getObjectValue(el, 'title', ''),
        href: getObjectValue(el, '_id', '')
      })),
      translations: {
        layoutTesto: {
          title: getObjectValue(element, 'title', ''),
          subtitle: getObjectValue(element, 'subtitle', ''),
          paragraph: getObjectValue(element, 'body', '')
        },
        layoutTasti: {
          card: getObjectValue(element, 'succesStories', [])?.map((el) => ({
            title: getObjectValue(el, 'title', ''),
            text: getObjectValue(el, 'body', ''),
            // da controllare
            button: getObjectValue(el, 'button', ''),
            href: getObjectValue(el, '_id', '')
          }))
        }
      }
    }));

    return {
      mainSectionDescriptions,
      mainSectionImageUrl,
      mainSectionDarkTheme,
      navbarItems,
      pages
    };
  }
}
